import { render, staticRenderFns } from "./Configure3DModelScale.vue?vue&type=template&id=3f3823a9&scoped=true&"
import script from "./Configure3DModelScale.vue?vue&type=script&lang=js&"
export * from "./Configure3DModelScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3823a9",
  null
  
)

export default component.exports